import { Alert, Platform } from 'react-native';
import { enqueueWebAlert, type AppAlertButton } from '../components/common/ConfirmDialog';

export type { AppAlertButton };

// RN-web's Alert.alert is a documented no-op (it logs a warning and shows
// nothing) — every existing Alert.alert call site was silently doing
// nothing on web. appAlert() is the drop-in replacement: native keeps using
// the real Alert.alert, web routes through AppAlertHost (ConfirmDialog.tsx),
// a queue-backed dialog mounted once at the app root by ConfirmProvider.
//
// Callable from anywhere — a hook, a store callback, an effect — not just
// from inside a component that's currently rendering. That matters because
// useConfirm() (the existing confirm() imperative API) throws when called
// from a gorhom sheet's portaled children, above ConfirmProvider in the
// tree (see MapLayersContent's doc comment); appAlert's web path is a plain
// module-level queue instead of a React context, so it has no such
// restriction.
//
// Direct import of ConfirmDialog, not the `../components/common` barrel —
// same reason MapLayersContent.tsx does it: tests that stub the barrel to
// sidestep gorhom/reanimated shouldn't also lose this.
export function appAlert(title: string, message?: string, buttons?: AppAlertButton[]): void {
  if (Platform.OS !== 'web') {
    Alert.alert(title, message, buttons);
    return;
  }
  enqueueWebAlert(title, message, buttons);
}
